import '../Pulsar.css';
import img2 from '../todos_recursos/juego2.png';
import img3 from '../todos_recursos/megadrive.png';
import img4 from '../todos_recursos/nesMario.png';
import img5 from '../todos_recursos/ventamaticCinta.png';
import img6 from '../todos_recursos/indescomp.png';


function Historia() {

    return(
<>
        
        

        <h1>La llegada de los videojuegos a España</h1>
        <img src={img6} alt='Imagen desarrolladores de videojuegos empresa española Indescomp años 80' className="imagenIzq" width="50%"/>
                <p>

                En la década de los 80, concretamente en el año 81, muchos jóvenes comenzaron a dejarse seducir por los consejos de un estudiante de ingeniería que hablaba de las 
                maravillas de un pequeño aparato: el Sinclair ZX81. En torno a este pequeño aparato nació un club, el Club Nacional de Usuarios del ZX81, un club de gente interesada 
                en conocer más sobre qué podía ofrecer el primer ordenador personal que comenzaba a llegar poco a poco a nuestro país. Este estudiante de ingeniería, llamado Josep-Oriol
                 Tomas, comenzó a encargarse tanto del club como de la importación de estos ordenadores, aprovechando la empresa de máquinas de vending de su padre; así nació, o 
                 evolucionó mejor dicho, Ventamatic. En la revista que editaba la asociación, comenzaron a publicarse los programas caseros de videojuegos que los propios miembros enviaban; 
                 este conocimiento compartido animó a muchos a comenzar con la programación de videojuegos en nuestro país. Cabe destacar que prácticamente nadie disponía de 
                 conocimientos previos sobre nada relacionado; era gente autodidacta con ganas de descubrir y compartir lo descubierto. Prácticamente al mismo tiempo, un avispado y 
                 atrevido vendedor, llamado José Luis Domínguez, había visto el negocio y fundó INDESCOMP —historia que merece sin duda un artículo aparte—, abriendo un camino que 
                 marcaría un punto de inicio en la industria de los videojuegos en España.
                </p>

                <p>
                Esta es una historia de descubrimiento, de gente valiente que dedicó días y noches enteras, en descuidadas oficinas sin amueblar, portando maletines vacíos. Auténticos 
                emprendedores con objetivos muy dispares, capaces de juntarse para sacrificar su tiempo; personas muy jóvenes, autodidactas, con fuertes valores y convencidos de que 
                algo nuevo estaba por descubrir. Estas personas llegaron a desarrollar y distribuir bastantes videojuegos programados en nuestra pequeña piel de toro. ¡Quién lo iba a 
                decir! Que nuestro país incluso participara en este auge del ocio tecnológico justo a las puertas del lanzamiento de NES (se lanzó en 1983 en Japón). Estos cimientos, sin duda, 
                fortalecieron la entrada de las primeras consolas; digamos que ya habíamos vivido un periodo de comprensión y aceptación de los videojuegos en nuestro país.

                </p>

                <img src={img2} alt='Capturas de diferentes videojuegos años 80/90' className='imagenCentrada' style={{width: '100%'}}/>
                
                <p>
                Con el lanzamiento de las primeras consolas es fácil perder el foco y pensar que la historia del videojuego está ligada a estas pequeñas máquinas, pero nada más lejos 
                de la realidad. Como ya hemos visto, estos entraron junto a los primeros ordenadores personales; esos ordenadores venían acompañados de un libro que daba pautas de 
                programación y abría la puerta a descubrir, precisamente lo que hicieron los pioneros de los que acabamos de hablar. Aunque el PC fue el primer soporte para estos juegos,
                 cabe destacar que fueron las consolas de videojuegos las que acercaron este arte digital a los hogares. Al final se necesitaban, por decirlo de alguna forma, menos 
                 conocimientos frente a un ordenador de sobremesa: solo debías insertar el cartucho, tomar el mando y disfrutar. También las consolas hicieron una grandísima campaña 
                 publicitaria sobre este nuevo entretenimiento, que se transformó en una gran industria con una competencia feroz por hacerse con los diferentes mercados que se 
                 repartían por continentes. Así comenzó esta segunda parte de la historia, con un videojuego moderno, asentado en una industria creciente que ya venía con dinámicas de trabajo y 
                 producto final... En esta segunda parte se vivieron unas batallas magníficas: nacimiento de empresas, estrategias, traiciones, caídas...
                </p>

                <div className='"galeria-dos-fotos"'>
                    <img src={img3} alt='Imagen de Sonic con Mega Drive de fondo' style={{ width: '55%'}}/>
                    <img src={img4} alt='Imagen de Mario con Super Nintendo de fondo' style={{ width: '40%'}}/>
                </div>
                
                <p>
                En general, la industria del videojuego goza de una magnífica historia que aún sigue escribiéndose, y de una evolución del producto y sus formatos que no tiene 
                precedentes. Sin ir más lejos, uno de los formatos con los que se comenzó fue fue la cinta de casete, como las que distribuía Ventamatic.
                </p>
        
                <img src={img5} alt='Videojuego de Ventamatic en cassete' className='imagenCentrada' style={{width: '50%'}}/>

                <p>
                Hasta el día de hoy, donde prácticamente ya no existe el formato físico, imponiéndose cada día más el digital. Esta es una industria que ha pasado por mucho y que, 
                en realidad, no tiene una sola historia; hemos repasado sobre todo la que concierne a nuestro país, pero difiere mucho de lo vivido en otras partes de Europa y otros 
                continentes, e incluso se puede remontar mucho más atrás.
                </p>

                
                <h3>¿No te preguntas hasta dónde podrá llegar esta industria?</h3>
                
</>
                
       
    )
    
}

export default Historia